import { ICallAndSetData } from "@/services/api-service/interface";
import { getSetApiData } from "@/services/api-service/get-set-api-data";
import { EHttpMethod } from "@/services/api-service/enums";

const GET_ACTIVE_SYSTEM_NOTIFICATIONS_URL = "/api/system-notifications/active";

const getActiveSystemNotificationsApi: ICallAndSetData = async (
  callApi,
  setState
) => {
  return await getSetApiData(
    callApi,
    EHttpMethod.GET,
    GET_ACTIVE_SYSTEM_NOTIFICATIONS_URL,
    setState
  );
};

export { getActiveSystemNotificationsApi };
